module.exports = {
          srcSet: __webpack_public_path__ + "70b1d41754e05230f4c468fe3a80d1c6-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "70b1d41754e05230f4c468fe3a80d1c6-66.jpg",width: 66,height: 44}],
          src: __webpack_public_path__ + "70b1d41754e05230f4c468fe3a80d1c6-66.jpg",
          toString:function(){return __webpack_public_path__ + "70b1d41754e05230f4c468fe3a80d1c6-66.jpg"},
          
          width: 66,
          height: 44
        }